module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Voucher")]), _vm._v(" "), _c('span', {}, [_c('router-link', {
    staticClass: "btn btn-xs btn-primary",
    attrs: {
      "to": "/receiptvoucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Receipt")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-xs btn-primary",
    attrs: {
      "to": "/contravoucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Contra")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-xs btn-primary",
    attrs: {
      "to": "/journalvoucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Journal")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-xs btn-primary",
    attrs: {
      "to": "/voucher"
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-default",
    attrs: {
      "type": "button",
      "title": "Reload Ledgers"
    },
    on: {
      "click": function($event) {
        return _vm.getBranch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 bg-green"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Accounting Voucher Creation")]), _vm._v(" "), _c('center', [_c('strong', [_vm._v(_vm._s(_vm.$store.state.settingRecord.companyName))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "background-color": "#FFFFD9"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id')
    },
    attrs: {
      "name": "branch_id",
      "accesskey": "b"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.loadBranchData()
      }]
    }
  }, _vm._l((_vm.branches), function(branch, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v(_vm._s(branch.name))])
  }), 0), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.voucherType),
      expression: "form.voucherType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('voucherType')
    },
    attrs: {
      "disabled": "",
      "name": "voucherType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "voucherType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "payment"
    }
  }, [_vm._v("Payment")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "voucherType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('strong', [_vm._v("No:")]), _vm._v(_vm._s(this.form.voucherNo) + "\r\n                            "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "voucherNo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('v-select', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "options": _vm.crledgers,
      "label": "name",
      "name": "cr_ledger",
      "placeholder": "Select",
      "accesskey": "l"
    },
    model: {
      value: (_vm.cr_ledger),
      callback: function($$v) {
        _vm.cr_ledger = $$v
      },
      expression: "cr_ledger"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "cr_ledger"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('i', [_vm._v("Cur Bal:"), _c('strong', [_vm._v(_vm._s(_vm.cr_ledger.balanceAmt) + " " + _vm._s((_vm.cr_ledger.balanceAmt >= 0) ? 'Dr' : 'Cr'))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.date),
      expression: "form.date"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('date')
    },
    attrs: {
      "type": "date",
      "name": "date",
      "accesskey": "d"
    },
    domProps: {
      "value": (_vm.form.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "date"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.holdTempVoucher()
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('add-ledger')], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('v-select', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "options": _vm.drledgers,
      "label": "name",
      "name": "dr_ledger",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.dr_ledger),
      callback: function($$v) {
        _vm.dr_ledger = $$v
      },
      expression: "dr_ledger"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "dr_ledger"
    }
  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amt),
      expression: "amt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": ".01",
      "name": "amt",
      "accesskey": "n"
    },
    domProps: {
      "value": (_vm.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', [_vm._l((_vm.holdVouchers), function(ledger, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\r\n                                        " + _vm._s(ledger.branchLedger.name) + "\r\n                                        "), _c('br'), _c('i', [_vm._v("Cur Bal:"), _c('strong', [_vm._v(_vm._s(ledger.branchLedger.balanceAmt) + " " + _vm._s((ledger.branchLedger.balanceAmt >= 0) ? 'Dr' : 'Cr'))])])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(ledger.amt))]), _vm._v(" "), _c('a', {
      staticClass: "text-danger",
      on: {
        "click": function($event) {
          return _vm.removeHoldVoucher(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('hr'), _c('strong', [_vm._v("Total: " + _vm._s(this.total))]), _c('hr'), _c('hr')])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.narration),
      expression: "form.narration"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.form.narration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "narration", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "~click": function($event) {
        return _vm.createVoucher()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('hr')])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("VoucherType "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Cr. Account "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', [_vm._v("Dr. Account "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', [_vm._v("Amt "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "title": "Submit",
      "accesskey": "s"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "80%"
    }
  }, [_vm._v("Particular")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Amount (Dr)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0cdc890!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/accounting/PaymentVoucher.vue
// module id = 887
// module chunks = 0